export default "__VITE_ASSET__CG56Hb$7__"